import { wordList } from "./axel_words";

function getRandomInt() {
  return Math.floor(Math.random() * wordList.length);
}

function randomWord() {
  return wordList[getRandomInt()];
}

// algo
export const wordId = (numWords: number) => {
  let words = [];

  words.push(randomWord());
  while (words.length < numWords) {
    let nextWord = randomWord();
    while (words.includes(nextWord)) {
      nextWord = randomWord();
    }
    words.push(nextWord);
  }
  return words.join("-");
};
